import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [admin,   setAdmin]   = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      axios.get('/api/auth/me')
        .then(res => setAdmin(res.data))
        .catch(() => {
          localStorage.removeItem('token');
          delete axios.defaults.headers.common['Authorization'];
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (username, password) => {
    const res = await axios.post('/api/auth/login', { username, password });
    localStorage.setItem('token', res.data.token);
    axios.defaults.headers.common['Authorization'] = `Bearer ${res.data.token}`;
    setAdmin(res.data.admin);
    return res.data.admin; // return role for redirect
  };

  const logout = () => {
    localStorage.removeItem('token');
    delete axios.defaults.headers.common['Authorization'];
    setAdmin(null);
  };

  const refreshAdmin = async () => {
    try {
      const res = await axios.get('/api/auth/me');
      setAdmin(res.data);
    } catch {}
  };

  const isSuperadmin = admin?.role === 'superadmin';
  const isPartner    = admin?.role === 'partner';
  const isAdmin      = admin?.role === 'admin' || isSuperadmin;

  return (
    <AuthContext.Provider value={{ admin, login, logout, loading, isSuperadmin, isPartner, isAdmin, refreshAdmin, setAdmin }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
